import { usePreferredLocaleContext } from "components/context/user/PreferredLocaleContext"

export function useGetPrivacyNoticeUrl(): string {
  const { preferredLocale } = usePreferredLocaleContext()

  return `https://www.get-carrot.com/${preferredLocale.toLocaleLowerCase()}/privacy-policy`
}
